import { render, staticRenderFns } from "./OrderForMe.vue?vue&type=template&id=6c99686f&scoped=true&"
import script from "./OrderForMe.vue?vue&type=script&lang=js&"
export * from "./OrderForMe.vue?vue&type=script&lang=js&"
import style0 from "./OrderForMe.vue?vue&type=style&index=0&id=6c99686f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99686f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c99686f')) {
      api.createRecord('6c99686f', component.options)
    } else {
      api.reload('6c99686f', component.options)
    }
    module.hot.accept("./OrderForMe.vue?vue&type=template&id=6c99686f&scoped=true&", function () {
      api.rerender('6c99686f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalCenter/OrderForMe/OrderForMe.vue"
export default component.exports